import { render, staticRenderFns } from "./dataprocess-form4.vue?vue&type=template&id=5c25ec6a&scoped=true&"
import script from "./dataprocess-form4.vue?vue&type=script&lang=ts&"
export * from "./dataprocess-form4.vue?vue&type=script&lang=ts&"
import style0 from "./dataprocess-form4.vue?vue&type=style&index=0&id=5c25ec6a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c25ec6a",
  null
  
)

export default component.exports